import AlreadySignupBlock from './AlreadySignupBlock';
import { AlreadySignupBlockProps, AlreadySignupBlockValueProps } from './types';

export type { AlreadySignupBlockProps, AlreadySignupBlockValueProps };
export default AlreadySignupBlock;
